import {
  IconMapMetroMsk16,
  IconMapMetroSpb16,
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
} from '@cian/ui-kit-design-tokens/icons';
import { ISVGIconProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';
import { TUndergroundType } from '../../../../../../types/newbuildingRecommendations';

const REGION_METRO_ICON_MAP = new Map<TUndergroundType, React.ComponentType<ISVGIconProps>>([
  ['mow', IconMapMetroMsk16],
  ['spb', IconMapMetroSpb16],
  ['ekb', IconMapMetroEkb16],
  ['kzn', IconMapMetroKzn16],
  ['nn', IconMapMetroNN16],
  ['nsk', IconMapMetroNovosib16],
  ['smr', IconMapMetroSam16],
]);

export function getRegionUndergroundIcon(undergroundType: TUndergroundType): React.ComponentType<ISVGIconProps> {
  const availableRegionId = REGION_METRO_ICON_MAP.has(undergroundType);

  return (availableRegionId && REGION_METRO_ICON_MAP.get(undergroundType)) || IconMapMetroMsk16;
}
